<div class="flex flex-wrap justify-between items-center border-b py-2 px-4">

    <div class="flex flex-wrap">
        <div class="text-3xl font-semibold">
            <div class="">{{ 'FILTER_BTN' | transloco }}</div>
        </div>

        <button class="ml-2"
                mat-icon-button
                (click)="onResetFilters()"
        >
            <mat-icon class="text-accent-400 icon-size-7" [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-wrap justify-between">

        <button
            mat-icon-button
            (click)="onApplyFilters()"
        >
            <mat-icon class="text-primary icon-size-7" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
        </button>

    </div>

</div>


<div class="flex flex-col px-4">

    @if (showSearch) {
        <mat-form-field [subscriptSizing]="'dynamic'" class="mt-2 w-full">
            <mat-label>{{ 'SEARCH' | transloco }}</mat-label>
            <input
                matInput
                type="text"
                [formControl]="searchControl"
                placeholder="Search Filters"
            />
            <button mat-icon-button matSuffix aria-label="Search icon">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    }

    <form [formGroup]="filterForm">

        <div *ngFor="let field of filteredFields()" class="my-4">

            <ng-container [ngSwitch]="field.type">
                <div *ngSwitchCase="'text'">
                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                        <mat-label>{{ field.label | transloco }}</mat-label>
                        <input
                            matInput
                            [formControlName]="field.name"
                            [placeholder]="field.placeholder"
                        />
                    </mat-form-field>
                </div>

                <div *ngSwitchCase="'multi-select'">
                    <div class="w-full">

                        <div
                            class="mb-1.5 font-medium leading-tight">{{ field.label | transloco }}
                            *
                        </div>

                        <ng-select class="custom"
                                   [formControlName]="field.name"
                                   [placeholder]="field.placeholder | transloco"
                                   [loadingText]="'LOADING' | transloco"
                                   [notFoundText]="'NO_RESULTS' | transloco"
                                   [multiple]="true"
                                   [items]="field.options | productionStatusArray"
                                   bindLabel="value"
                                   bindValue="key"
                        >

                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                @for (item of items | slice: 0 : 2; track item) {
                                    <div class="ng-value">

                                        @if (field.name == 'production_status_ids') {
                                            <span class="ng-value-label">{{ item.value | productionStatus }}</span>
                                        } @else {
                                            <span class="ng-value-label">{{ item.value }}</span>
                                        }
                                        <span class="ng-value-icon right" (click)="clear(item)"
                                              aria-hidden="true">×</span>
                                    </div>
                                }
                                @if (items.length > 2) {
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length - 2 }} more...</span>
                                    </div>
                                }
                            </ng-template>

                        </ng-select>

                        <mat-error class="text-sm font-semibold"
                                   *ngIf="filterForm.get(field.name).touched && filterForm.get(field.name).hasError('required')">
                            {{ 'REQUIRED_FIELD' | transloco }}
                        </mat-error>

                    </div>
                </div>

                <div *ngSwitchCase="'checkbox'">
                    <mat-checkbox [formControlName]="field.name">
                        {{ field.label | transloco }}
                    </mat-checkbox>
                </div>

                <div *ngSwitchCase="'date'">

                    <div class="font-medium"> {{ field.label }}</div>
                    <div
                        class="relative mt-1.5 mb-2 flex cursor-pointer items-center rounded-md px-2 leading-10 bg-primary-200 text-accent-800 dark:bg-accent-500 dark:text-accent-100"
                        (click)="dtFilter.open()">
                        <mat-icon
                            class="text-current icon-size-5"
                            [svgIcon]="'heroicons_solid:calendar'"
                        ></mat-icon>
                        <span class="ml-2 text-md font-medium">
                                @if (filterForm.get(field.name).value) {
                                    {{ filterForm.get(field.name).value | date: 'dd.MM.yyyy' }}
                                }
                            @if (!filterForm.get(field.name).value) {
                                {{ 'REQUIRED_FIELD' | transloco }}
                            }
                            </span>
                        <mat-form-field
                            class="fuse-mat-dense pointer-events-none invisible absolute inset-0 -mt-2.5 opacity-0"
                            [subscriptSizing]="'dynamic'">
                            <input
                                matInput
                                [formControlName]="field.name"
                                [matDatepicker]="dtFilter"
                            />
                            <mat-datepicker #dtFilter>
                                <mat-datepicker-actions>
                                    <button
                                        mat-button
                                        (click)="filterForm.get(field.name).setValue(null)"
                                        matDatepickerCancel>
                                        {{ 'CANCEL' | transloco }}
                                    </button>
                                    <button
                                        class=""
                                        mat-flat-button
                                        [color]="'primary'"
                                        matDatepickerApply
                                    >
                                        {{ 'CONFIRM' | transloco }}
                                    </button>
                                </mat-datepicker-actions>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>

                </div>

                <div *ngSwitchCase="'date-range'">
                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                        <mat-label>{{ field.label | transloco }}</mat-label>
                        <mat-date-range-input [rangePicker]="dateRangePicker" [formGroupName]="field.name">
                            <input
                                matInput
                                matStartDate
                                formControlName="start"
                                placeholder="{{ field.placeholderFrom || 'Start date' | transloco }}"
                            />
                            <input
                                matInput
                                matEndDate
                                formControlName="end"
                                placeholder="{{ field.placeholderTo || 'End date' | transloco }}"
                            />
                        </mat-date-range-input>

                        <!--                        <mat-hint>1.1.2000 – 1.31.2000</mat-hint>-->

                        <mat-datepicker-toggle matIconSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
                        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>

                        <mat-error
                            *ngIf="filterForm.get(field.name).get('start').hasError('matStartDateInvalid')">
                            Invalid start date
                        </mat-error>
                        <mat-error *ngIf="filterForm.get(field.name).get('end').hasError('matEndDateInvalid')">
                            Invalid end date
                        </mat-error>

                    </mat-form-field>
                </div>

                <div *ngSwitchCase="'number'">
                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                        <mat-label>{{ field.label | transloco }}</mat-label>
                        <input
                            matInput
                            type="number"
                            [formControlName]="field.name"
                            [placeholder]="field.placeholder"
                        />
                    </mat-form-field>
                </div>

                <div *ngSwitchCase="'select'">
                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                        <mat-label>{{ field.label | transloco }}</mat-label>
                        <mat-select [formControlName]="field.name">
                            <mat-option
                                *ngFor="let option of field.options"
                                [value]="option.key"
                            >
                                {{ option.value }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div *ngSwitchDefault>
                    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
                        <mat-label>{{ field.label | transloco }}</mat-label>
                        <input
                            matInput
                            [formControlName]="field.name"
                            [placeholder]="field.placeholder"
                        />
                    </mat-form-field>
                </div>
            </ng-container>
        </div>

        <!--        <div class="flex flex-wrap justify-between mt-4 space-x-2">-->
        <!--        <div class="sm:absolute sm:inset-x-0 sm:bottom-0 flex flex-wrap justify-between p-4 border-t">-->

        <!--            <button-->
        <!--                mat-stroked-button-->
        <!--                type="button"-->
        <!--                (click)="onResetFilters()"-->
        <!--                class="text-gray-600"-->
        <!--            >-->
        <!--                {{ 'RESET' | transloco }}-->
        <!--            </button>-->

        <!--            <button mat-flat-button color="primary" (click)="onApplyFilters()">-->
        <!--                {{ 'CONFIRM' | transloco }}-->
        <!--            </button>-->

        <!--        </div>-->

    </form>
</div>
